var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "no-data w-100 d-flex flex-column justify-content-center align-items-center my-5"
    },
    [
      _c("i", {
        staticClass: "no-data__icon fad fa-empty-set mb-5 text-secondary"
      }),
      _vm._v(" "),
      _c("p", { staticClass: "no-data__text text-center font-weight-bold" }, [
        _vm._v(_vm._s(_vm.message))
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }